import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { ActivatedRoute, Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import moment from "moment/moment";
import { OrdersService } from "../../../../auth/service/orders.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommissionService } from "../../../../auth/service/commission.service";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { CustomerService } from "../../../../modules/customer/customer.service";

@Component({
  selector: "app-orders-list",
  templateUrl: "./orders-list.component.html",
  styleUrls: ["./orders-list.component.scss"],
})
export class OrdersListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public orders: any = [];
  public filterOrders: any = [];
  public filter_customer: number = 0;
  public todayDate: any = moment();
  public selectedCommissionID: number = null;
  public commissionList: any = [];
  public customersList: any = [];
  public filter_status_round: number = -1;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
    public _orderService: OrdersService,
    private router: Router,
    private _customerService: CustomerService,
    private _modalService: NgbModal,
    private _commissionService: CommissionService,
    private activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.ORDERS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.COMMISSION,
            isLink: false,
          },
          {
            name: italian.data.MENU.ORDERS,
            isLink: false,
          },
        ],
      },
    };
    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const client = params.client;
      const statusRound = params.status_round;

      if (!!searchKey && searchKey != 0) {
        this.searchKey = searchKey;
      }
      if (!!client && Number(client) > 0) {
        this.filter_customer = Number(client);
      }
      if (!!statusRound && Number(statusRound) >= 0) {
        this.filter_status_round = Number(statusRound);
      }
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_orders")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.commissionList = await this._commissionService.getCommissions();
    this.customersList = await this._customerService.getCustomers();
    this.customersList = this.customersList.sort((a, b) => (a.name > b.name ? 1 : -1));
    await this.loadOrders();
    await this.searchOrder();
    this._utilService.hideLoading();
  }

  async loadOrders() {
    this.orders = await this._orderService.getOrders();
    this.orders = this.orders.sort((a, b) => (a.from < b.from ? 1 : -1));
    if (this.orders && this.orders.length > 0) {
      this.orders.map((order) => {
        order.residue_formatted = this._utilService.addDotsToNumber(order.residue);
        order.capacity_formatted = this._utilService.addDotsToNumber(order.capacity);
        if (moment(order?.from) > this.todayDate && order.status === 0) {
          order.label = italian.data.NOT_STARTED; //NOT_STARTED
          order.status_number = 0; //NOT_STARTED
          order.status_color = "warning";
        }
        if (moment(order?.from) <= this.todayDate && moment(order?.to) > this.todayDate && order.status === 0) {
          order.label = italian.data.ACTIVATED_MASCULIN;
          order.status_number = 1; //STARTED && ACTIVATED
          order.status_color = "success";
        }
        if (moment(order?.to) < this.todayDate && order.status === 0) {
          order.label = italian.data.EXPIRED;
          order.status_number = 2; //EXPIRED
          order.status_color = "danger";
        }
        if (order.status === 1) {
          order.label = italian.data.CLOSE_MASCULIN;
          order.status_number = 3; //CLOSED
          order.status_color = "danger";
        }
      });
    }
  }

  async searchOrder() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filterOrders: any = this.orders;
    if (key.length > 0) {
      filterOrders = filterOrders.filter(
        (item: any) =>
          item.commission?.protocol.toLowerCase().trim().includes(key) ||
          item.commission?.client?.name.toLowerCase().includes(key) ||
          item.capacity_formatted.toLowerCase().includes(key) ||
          item.residue_formatted.toLowerCase().includes(key),
      );
    }
    if (this.filter_customer > 0) {
      filterOrders = filterOrders.filter((item: any) => item.commission?.client?.id === this.filter_customer);
    }
    if (this.filter_status_round > -1) {
      filterOrders = filterOrders.filter((item: any) => item.status_number == this.filter_status_round);
    }

    this.filterOrders = filterOrders;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKey && this.searchKey.length >= 3) {
      url.searchParams.set("search", String(this.searchKey));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_customer && Number(this.filter_customer) > 0) {
      url.searchParams.set("client", String(this.filter_customer));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("client");
      history.pushState({}, "", url);
    }

    if (this.filter_status_round > -1) {
      url.searchParams.set("status_round", String(this.filter_status_round));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status_round");
      history.pushState({}, "", url);
    }
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async modalOpen(modalBasic) {
    this._modalService.open(modalBasic, {
      size: "s,",
      centered: true,
    });
  }

  modalClose() {
    this.selectedCommissionID = null;
    this._modalService.dismissAll();
  }

  async deleteOrder(order: any) {
    if (!this._authenticationService.hasCapability("delete_order")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${order?.commission?.client?.name} ${order?.commission?.protocol}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._orderService
            .deleteOrder(order.id)
            .then(async () => {
              this.filterOrders = this.filterOrders.filter((item) => item.id != order.id);
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_ROUND" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND" });
      });
  }

  async createOrder() {
    await this.router.navigate([`/dashboard/commission/edit/${this.selectedCommissionID}`], { queryParams: { add_order: true } });
  }
}
